import { Grid, TextField, Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import { useFormik } from "formik";
import { SMART_S_CONDITION_TYPE } from "libs/configs/constant";
import useModalLoading from "libs/hooks/useModalLoading";
import usePrevious from "libs/hooks/usePrevious";
import { getErrorMessage, isError, mapFieldValidate } from "libs/utils/form";
import { get } from "lodash";
import mrz from "mrz";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import {
  addPopupSmartForm,
  addSmartFormSlice,
  getCoditionType,
  getCoditionVisa,
  getSmartForm,
  getSmartFormFieldConfig,
  selectAddSmartForm,
  selectCoditionType,
  selectCoditionVisa,
  selectCurrentSmartServiceId,
  selectSmartFormFieldConfig
} from "redux/modules/visaForm";
import * as yup from "yup";

const x = mrz.parse;

const ConditionType = {
  Company: "Company",
  Government: "Government",
  START_UP: "Start up",
  VENTURE_CAPITAL: "Venture Capital",
  YEAR_1: "1 Year",
  YEAR_2: "1 Year",
  MONTH_1: "1 Year",
};

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: "18px 48px",
    width: 820,
  },
  title: {
    color: theme.palette.darkIndigo.main,
  },
  label: {
    color: "#172b4d",
    height: 34,
  },
  formControl: {
    margin: theme.spacing(1),
    display: "flex",
    flex: 1,
  },
  currencyCode: {
    margin: theme.spacing(1),
    width: 100,
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  buttonUpload: {
    margin: theme.spacing(1),
    height: 54,
    width: 140,
    border: "1px solid rgba(0, 0, 0, 0.23);",
    color: theme.palette.secondary.main,
  },
  uploadStatus: {
    display: "flex",
    flex: 1,
    margin: theme.spacing(1),
    height: 54,
    borderRadius: 7,
    border: "1px solid rgba(0, 0, 0, 0.23);",
    alignItems: "center",
    padding: "0px 17px",
  },
  bulletStatus: {
    width: 18,
    height: 18,
    borderRadius: 18,
    marginRight: theme.spacing(1),
  },
  errorText: {
    marginLeft: theme.spacing(3),
  },
}));

export default function RequestTalentForma({
  onCancel = () => { },
  onSubmit = () => { },
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const modalLoading = useModalLoading();

  const personalDetailState = useSelector(selectPersonalDetail);
  const smartVisaServiceId = useSelector(selectCurrentSmartServiceId);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const fieldConfigState = useSelector(selectSmartFormFieldConfig);
  const coditionType = useSelector(selectCoditionType);
  const {
    isLoading,
    isSuccess,
    data: coditionVisa,
  } = useSelector(selectCoditionVisa);

  useEffect(() => {
    if (addSmartFormState.isLoading) {
      modalLoading.showLoading();
    } else {
      if (addSmartFormState.isSuccess) {
        modalLoading.hideLoading();
        onSubmit();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      } else if (addSmartFormState.isFailure) {
        modalLoading.hideLoading();
        alert(JSON.stringify(addSmartFormState.error));
      }
    }
  }, [
    addSmartFormState.error,
    addSmartFormState.isFailure,
    addSmartFormState.isLoading,
    addSmartFormState.isSuccess,
    dispatch,
    modalLoading,
    onSubmit,
  ]);

  useEffect(() => {
    if (smartVisaServiceId) {
      dispatch(
        getCoditionVisa({
          smartVisaServiceId,
          ConditionType: "1YA",
        })
      );
      dispatch(getCoditionType({ smartserviceId: smartVisaServiceId }));
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartVisaServiceId }));
    }
  }, [dispatch, smartVisaServiceId]);

  const extraField = get(coditionVisa, "extraType", []);
  const validationSchema = yup.object({
    ...extraField.reduce(mapFieldValidate, {}),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ConditionType: "1YA",
      ...extraField.reduce((p, c) => ({ ...p, [c.conditionField]: "" }), {}),
    },
    validationSchema,
    onSubmit: async (values) => {
      const defaultType = get(fieldConfigState, "data.defaultType", []);
      const getFieldListConfig = defaultType.filter((field) =>
        ["ConditionType"].includes(field.smartName)
      );

      const getValue = (field) => {
        if (field.smartName === "ConditionType") {
          return `${values[field.smartName]}` || null;
        }

        return `${values[field.smartName]}` || null;
      };

      const prepareData = {
        draftId: null,
        smartserviceId: smartVisaServiceId,
        personalId: get(personalDetailState, "personalID", ""),
        survey: null,
        visaissuance: null,
        detail: [
          ...getFieldListConfig.map((field) => ({
            smartName: field.smartName,
            smartId: null,
            partfromId: field.partfromId,
            configsmartId: field.configsmartId,
            linkTable: "",
            value: getValue(field),
          })),
        ],
      };

      const response = await dispatch(
        addPopupSmartForm({
          data: prepareData,
          images: [],
        })
      );
      await dispatch(getSmartForm({ draftId: response?.payload?.draftId }))
      // onSubmit(values);
    },
  });

  const prevConditionType = usePrevious(formik.values.ConditionType);
  const currentConditionType = formik.values.ConditionType;

  useEffect(() => {
    if (prevConditionType !== currentConditionType) {
      dispatch(
        getCoditionVisa({
          smartVisaServiceId,
          ConditionType: currentConditionType,
        })
      );
    }
  }, [dispatch, smartVisaServiceId, currentConditionType, prevConditionType]);

  return (
    <div className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        QUALIFICATION ENDORSEMENT FOR SMART VISA “S”
      </Typography>
      <Typography variant="h4" color="secondary">
        Qualifications and Criteria
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1} style={{ marginTop: 30 }}>
          <Grid item xs={12} md={6}>
            <Typography variant="h6" className={classes.label}>
              Please select only one
            </Typography>
            <FormControl variant="outlined" className={classes.formControl}>
              <Select
                value={formik.values.ConditionType}
                name="ConditionType"
                onChange={formik.handleChange}
                MenuProps={{
                  elevation: 2,
                  getContentAnchorEl: null,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "center",
                  },
                }}
              >
                {Object.keys(SMART_S_CONDITION_TYPE).map((cdType) => (
                  <MenuItem key={cdType} value={cdType}>
                    {SMART_S_CONDITION_TYPE[cdType]}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {[...extraField].map((field) => (
            <Grid item xs={12} md={6} key={field.conditionField}>
              <Typography variant="h6" className={classes.label}>
                {field.conditionField}
              </Typography>
              <TextField
                className={classes.formControl}
                variant="outlined"
                placeholder={field.conditionField}
                name={field.conditionField}
                type={
                  ["int", "double"].includes(field.conditionValue)
                    ? "number"
                    : "text"
                }
                value={formik.values[field.conditionField]}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError(field.conditionField, formik)}
                helperText={getErrorMessage(field.conditionField, formik)}
              />
            </Grid>
          ))}

          <Grid item xs={0} md={8}></Grid>
          <Grid item xs={12} md={2}>
            <ColorButton
              size="large"
              fullWidth
              variant="outlined"
              onClick={onCancel}
            >
              Cancel
            </ColorButton>
          </Grid>
          <Grid item xs={12} md={2}>
            <ColorButton
              size="large"
              fullWidth
              variant="contained"
              color="secondary"
              disabled={false}
              type="submit"
            >
              Next
            </ColorButton>
          </Grid>
        </Grid>
      </form>
    </div>
  );
}
